import React from 'react';
import { Settings, Info } from 'lucide-react';

/**
 * Компонент раздела формы с дополнительными параметрами расчета
 */
const AdditionalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  // Определяем, показывать ли этот раздел в зависимости от типа вычета
  const showSection = formData.deductionType === 'comprehensive';
  
  if (!showSection) return null;
  
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Settings className="w-5 h-5 mr-2 text-gray-500" />
        Дополнительные параметры расчета
      </h3>
      
      <div className="flex items-start mb-4 p-3 bg-amber-50 dark:bg-amber-900/20 border border-amber-100 dark:border-amber-800 rounded-lg">
        <Info className="w-5 h-5 text-amber-600 dark:text-amber-400 mr-3 mt-0.5 flex-shrink-0" />
        <div>
          <h4 className="text-sm font-medium text-amber-700 dark:text-amber-300 mb-1">
            Оптимизация налоговых вычетов
          </h4>
          <p className="text-xs text-amber-600 dark:text-amber-400">
            В режиме комплексного расчета вычетов калькулятор оптимизирует порядок получения вычетов
            для максимально быстрого возврата НДФЛ с учетом ограничений по типам вычетов и годовому доходу.
          </p>
        </div>
      </div>

      <div className="space-y-3">
        <p className="text-sm text-gray-700 dark:text-gray-300">
          Оптимальный порядок получения вычетов:
        </p>
        
        <ol className="list-decimal pl-5 space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <li>
            <span className="font-medium text-gray-800 dark:text-gray-200">Имущественный вычет</span> 
            <span className="text-xs"> (используется в первую очередь, т.к. имеет самый большой лимит и переносится на следующие годы)</span>
          </li>
          <li>
            <span className="font-medium text-gray-800 dark:text-gray-200">Вычет по ипотечным процентам</span> 
            <span className="text-xs"> (большой лимит, переносится на следующие годы)</span>
          </li>
          <li>
            <span className="font-medium text-gray-800 dark:text-gray-200">Вычет по ИИС типа А</span> 
            <span className="text-xs"> (ежегодный вычет, использование повышает доходность инвестиций)</span>
          </li>
          <li>
            <span className="font-medium text-gray-800 dark:text-gray-200">Социальные вычеты</span> 
            <span className="text-xs"> (лечение, обучение - не переносятся на следующие годы, используются или сгорают)</span>
          </li>
          <li>
            <span className="font-medium text-gray-800 dark:text-gray-200">Вычет на благотворительность</span> 
            <span className="text-xs"> (использование зависит от размера пожертвований)</span>
          </li>
        </ol>

        <div className="mt-3 p-3 bg-gray-100 dark:bg-gray-700 rounded-lg">
          <p className="text-xs text-gray-700 dark:text-gray-300 italic">
            При комплексном расчете учитываются ограничения по каждому типу вычета и 
            общего налога на доходы физических лиц, который вы уплатили за год. 
            Рекомендуется подать документы на все подходящие вычеты одновременно.
          </p>
        </div>
      </div>

      {/* Расчет и оформление */}
      <div className="mt-4">
        <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Способы получения вычетов:
        </h4>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div className="p-3 border border-gray-200 dark:border-gray-700 rounded-lg">
            <h5 className="text-sm font-medium text-gray-800 dark:text-gray-200 mb-1">
              Через налоговую инспекцию
            </h5>
            <ul className="text-xs text-gray-600 dark:text-gray-400 list-disc pl-4 space-y-0.5">
              <li>Подача декларации 3-НДФЛ по окончании года</li>
              <li>Перенос остатка вычетов на следующие годы</li>
              <li>Возврат на банковский счет в течение ~3 месяцев</li>
            </ul>
          </div>
          
          <div className="p-3 border border-gray-200 dark:border-gray-700 rounded-lg">
            <h5 className="text-sm font-medium text-gray-800 dark:text-gray-200 mb-1">
              Через работодателя
            </h5>
            <ul className="text-xs text-gray-600 dark:text-gray-400 list-disc pl-4 space-y-0.5">
              <li>Освобождение от НДФЛ с з/п в течение года</li>
              <li>Не требует заполнения декларации 3-НДФЛ</li>
              <li>Для имущественных и некоторых социальных вычетов</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalParametersSection;